import * as React from 'react'
import styled from 'styled-components'

const FormField = ({ children, label = '', labelFor = null, ...props }) => (
  <Wrapper {...props}>
    {label && <Label htmlFor={labelFor}>{label}</Label>}
    <Content>{children}</Content>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const Content = styled.div`
  ${(props) => (props.width ? `width: ${props.width}px` : 'width:100%;')};
  min-height: 30px;
  align-items: center;
  display: flex;
`

const Label = styled.label`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 12px;
`

export default FormField
